import { random, times } from 'lodash-es';
import React from 'react';

import { Skeleton } from '@mui/material';

import useStyles from './styles';

interface Props {
    className?: string;
}

const PostCard: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <Skeleton variant="text" className={classes.published} />

            <div className={classes.content}>
                <div>
                    {times(2, (index) => (
                        <Skeleton key={index} variant="text" width={`${random(50, 100)}%`} height={30} />
                    ))}
                </div>
                <div>
                    {times(5, (index) => (
                        <Skeleton key={index} variant="text" width={`${random(50, 100)}%`} height={24} />
                    ))}
                </div>
            </div>

            <div className={classes.tags}>
                {times(2, (index) => (
                    <Skeleton key={index} variant="text" width={random(30, 80)} height={16} className={classes.tag} />
                ))}
            </div>
        </div>
    );
};

export default PostCard;
